import { apiRequest } from './client';
import { getApiToken } from './authToken';
import { toJsonSafe } from './json';

export async function listAppointments({ companyId, from, to, clientId, archived, token }) {
  const authToken = token || (await getApiToken());
  const params = new URLSearchParams();
  if (from) params.set('from', from instanceof Date ? from.toISOString() : String(from));
  if (to) params.set('to', to instanceof Date ? to.toISOString() : String(to));
  if (clientId) params.set('clientId', clientId);
  if (archived) params.set('archived', String(archived));
  const query = params.toString();
  const path = `/api/companies/${encodeURIComponent(companyId)}/appointments${query ? `?${query}` : ''}`;
  return apiRequest(path, { token: authToken });
}

export async function getAppointment({ companyId, id, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(id)}`,
    { token: authToken }
  );
  return result.appointment;
}

export async function getAppointmentOrNull({ companyId, id, token }) {
  try {
    return await getAppointment({ companyId, id, token });
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
}

export async function upsertAppointment({ companyId, id, appointment, token }) {
  const authToken = token || (await getApiToken());
  return apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(id)}`,
    {
      token: authToken,
      method: 'PUT',
      body: { appointment: toJsonSafe(appointment) },
    }
  );
}

export async function deleteAppointmentApi({ companyId, id, token }) {
  const authToken = token || (await getApiToken());
  return apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(id)}`,
    {
      token: authToken,
      method: 'DELETE',
    }
  );
}
